// Using double quotes in this file to prevent issues with apostrophes (')
export default {
  header: {
    ai: {
      title: 'Pergunte ao HP Nio',
      close: 'Fechar bate-papo Nio',
      open: 'Abrir bate-papo Nio',
      morningGreeting: "Bom dia, {0}.",
      afternoonGreeting: "Boa tarde, {0}.",
      eveningGreeting: "Boa noite, {0}.",
      morningGreetingGeneric: "Bom dia,",
      afternoonGreetingGeneric: "Boa tarde,",
      eveningGreetingGeneric: "Boa noite,",
      opening: "Sou Nio. Como posso ajudar?",
      openingPrivacy: "Eu sou Nio.",
      pbIntro1: "Pergunte-me sobre a produtividade do dispositivo.",
      alertDefault: "Estou na fase inicial de desenvolvimento, portanto ainda não posso responder a perguntas <b>{0}</b>.",
      intro2:  "Eis algumas perguntas que podem ser interessantes:",
      kzIntro1: "Pergunte-me sobre suas preocupações e responderei com as informações da Zona de Conhecimento.",
      pbSample1: "Qual a produtividade do local ontem?",
      pbSample2: "Como posso melhorar a produtividade?",
      pbSample3: "Qual impressora está superando as restantes?",
      pbSample4: "Que substrato gerou maior perda de tempo?",
      pbSample5: "Qual problema me tomou mais tempo na semana passada?",
      kzSample1: "Como reduzir o desperdício de substrato e cortar custos sem prejudicar a qualidade?",
      kzSample2: "Qual impressora HP Indigo melhor para impressão eficiente com cores consistentes para rótulos de vinho?",
      kzSample3: "Como otimizar o uso de suprimentos para aumentar a produtividade?",
      kzSample4: "Que principais fatores de sustentabilidade devo considerar na impressão?",
      kzSample5: "Como garantir a consistência da cor entre as impressoras HP Indigo 6000 e 20K?",
      feedbackTitle: "Razão para a sua pontuação",
      feedbackPlaceholder: "Você consegue explicar com detalhes o que aconteceu?",
      fbPositive1: "Os dados estão corretos",
      fbPositive2: "Resposta muito boa",
      fbPositive3: "Muito detalhado",
      fbPositive4: "A resposta foi relevante",
      fbOther: "Outro",
      fbNegative1: "As informações ou dados não estão corretos",
      fbNegative2: "A resposta não resolveu minha dúvida",
      fbNegative3: "A resposta foi confusa ou sem clareza",
      fbNegative4: "A resposta não foi relevante",
      feedbackSubmittedTitle: "Agradecemos o seu feedback",
      feedbackSubmittedDescription_Positive: "Que bom que a resposta foi útil! Seu feedback nos incentiva a continuar fornecendo experiências melhores.",
      feedbackSubmittedDescription_Negative: "Aceite nossas desculpas por qualquer inconveniência que possa ter ocorrido. Nossa equipe analisará as informações e trabalhará para corrigi-las. Se tiver mais detalhes sobre o erro ou feedback adicional, informe-nos para nos ajudar a melhorar.",
      ask_Placeholder: "O que você gostaria de saber?",
      answerCopiedToClipboard: "Resposta copiada para a área de transferência",
      feedbackSubmitted: "Opinião enviada",
      feedbackCleared: "Feedback removido",
      newConversation: "Novo bate-papo",
      chatHistory: "Histórico de bate-papo",
      submitQuestion: "Enviar pergunta",
      responseError: "Opa, parece que encontramos um problema aqui. Tente mais tarde.  Se o problema persistir, entre em contato com a assistência.",
      responseError400: "Parece que sua pergunta tem caracteres inesperados. Remova-os para continuar.",
      responseError429: "Calma aí, não consigo acompanhar tantas perguntas.",
      like: "Gostei",
      dislike: "Não gostei",
      copy: "Copiar para área de transferência",
      retry: "Repetir",
      contact: "Fale conosco",
      contactSubject: "Problema no HP Nio",
      contactQuestion: "Pergunta: {0}",
      noConversations: "Você não tem conversas",
      startConversation: "Comece uma conversa para ver aqui seu histórico de bate-papo",
      today: "Hoje",
      yesterday: "Ontem",
      privacyNotice: "Você está interagindo com uma solução de IA",
      privacy1: "Você está para começar um chat com uma solução de IA. Esses chats podem ser analisados e usados para treinar nossos modelos.",
      privacy2: `If you prefer to receive support in another way, please visit {0}.`,
      acceptPrivacy: "Comece um chat com o HP Nio"
    },
    apps: {
      title: "Menu",
      externalLinks: "Externo",
      availableApps: "Explorar",
      configure: "Personalizar",
      showApp: "Exibir",
      hideApp: "Ocultar",
      setDefault: "Definir aplicativo padrão",
      setShortcut: "Definir como fixo",
      removeShortcut: "Desafixar",
      showAllApps: "Exibir todos os aplicativos",
      shortCutTooltip: "Ir para {0}",
      currentAccount: "Organização atual",
      goHome: "Ir para a página inicial",
      goAppHome: "Ir para a página inicial do aplicativo",
      byProvider: "por {0}",
      quickFilter: "Localizar aplicativo...",
      allApps: "Todos os aplicativos",
      recentApps: "Recente",
      externalApp: "Aplicativo externo ao PrintOS",
      modeSwitcher: "Modo Claro/Escuro",
      goProducts: "Explorar mais aplicativos"
    },
    panels: {
      ai: "Pergunte ao HP Nio",
      notifications: "Minhas notificações",
      help: "Ajuda e suporte",
      user: "Usuário",
      close: "Fechar painel",
      moveLeft: "Mover para a esquerda",
      moveRight: "Mover para a direita",
      maximize: "Maximizar",
      restore: "Restaurar",
    },
    user: {
      account: "Organização",
      returnToHP: "Voltar para HP Inc.",
      myOrganization: "Minha organização",
      myOrganizations: "Minhas organizações",
      myReports: "Meus relatórios",
      mySettings: "Minhas configurações",
      signOut: "Sair",
      signInExplanation: "Entre no HP PrintOS para ver notificações e aplicativos.",
      signIn: "Login",
      RCDA: "Acesso do cliente",
      orphanUser: "Usuário do PrintOS",
      orphanContext: "Nenhuma organização",
      deviceUser: "Dispositivo PrintOS",
      anonymous: "Usuário anônimo",
      name: "Nome",
      email: "Email",
      address: "Endereço",
      editUser: "Editar conta HP",
      viewPrivacy: "Ver declaração de sigilo"
    },
    date: {
      fewSecondsAgo: "há poucos segundos",
      minuteAgo: "há um minuto",
      minutesAgo: "há {0} minutos",
      hourAgo: "há uma hora",
      hoursAgo: "há {0} horas",
      dayAgo: "há um dia",
      daysAgo: "há {0} dias",
      monthAgo: "há um mês",
      monthsAgo: "há {0} meses",
      yearAgo: "há um ano",
      yearsAgo: "há {0} anos",
    },
    help: {
      quickFilter: "Pesquisa",
      page: "Página",
      app: "Aplicativo",
      newFeatures: "Novos recursos",
      more: "Todos",
      contactHP: "Entre em contato com a HP",
      noTopics: "Nenhum tópico de ajuda correspondente",
      about: "Sobre",
      terms: "Termos de serviço",
      readFile: "Documento",
      stepByStepTutorial: "Tutorial",
      goLink: "Página do aplicativo",
      viewVideo: "Vídeo",
      goToUrl: "Link",
      other: "Outro",
      faq: "Perguntas frequentes",
      new: "Novo tópico",
      whatsNew: "O que há de novo?",
      technicalSupport: "Suporte de PrintOS",
      printOSFeedback: "Comentários do PrintOS",
      conversationsWithHP: "Conversas com a HP",
      youMayConsider: "Você pode considerar...",
      myKzArticles: "Meus artigos da Knowledge Zone",
      kzServiceTopics: "{0} ({1})",
      lkcArticles: "Artigos do HP Latex Knowledge Center",
    },
    notifications: {
      noNotifications: "Não há notificações",
      viewAll: "Ver tudo",
      dismiss: "Descartar",
      dismissAll: "Descartar todos",
      subscriptions: "Configurações",
    },
    marketplace: {
      title: "Marketplace",
      explore: "Explorar tudo",
      featured: "Em destaque",
      slides: {
        default: {
          description: "Aprimore o PrintOS com aplicativos, extensões e conectores exclusivos"
        },
        oee: {
          title: "Print Beat OEE",
          description: "Promove excelência operacional com percepções baseadas em dados quase em tempo real",
        },
      },
      partialProductivitySubscribePreEnforcement_Title: "O acesso aos serviços Indigo Print Beat, Trabalhos, OEE e Print Beat requerem a <a href='https:/intercom.help/hp-printos/en/articles/11113950-hp-printos-productivity-power-pack' target='_blank'>assinatura do Productivity Power Pack</a> a partir de 4 de agosto.",
      partialProductivitySubscribePreEnforcement_Desc: "Os dados dos dispositivos sem assinatura podem ser extraídos antes de agosto.",
      partialProductivitySubscribePostEnforcement_Title: "Nem todos os seus dispositivos Indigo estão inscritos para o Power Pack Productivity ({0}/{1})",
      partialProductivitySubscribePostEnforcement_Desc: "Dispositivos sem assinatura podem limitar sua experiência no PrintOS (Print Beat, Jobs, OEE, Dashboards etc.).",
      goToMarket_Action: "Vá para o Marketplace",
      howToExtract_Action: "Como extrair meus dados"
    },
    focus: {
      title: "Foco",
    },
    locales: {
      "de-DE": "Alemão",
      "en-GB": "Inglês (Reino Unido)",
      "en-US": "Inglês (EUA)",
      "es-ES": "Espanhol",
      "fr-FR": "Francês",
      "it-IT": "Italiano",
      "ja-JP": "Japonês",
      "ko-KO": "Coreano",
      "pt-PT": "Português",
      "tr-TR": "Turco",
      "zh-HANS": "Chinês (simplificado)",
      "ru-RU": "Russo",
      "Tradução parcial": "Traduções parciais",
    },
    modal: {
      ok: "Ok",
      cancel: "Cancelar",
    },
    combo: {
      noItems: "Sem correspondência",
    },
    nps: {
      question: "Olá, {0}. Qual é a probabilidade de você recomendar o PrintOS a um colega?",
      // In case we can't get user's display name
      questionNameless: "Qual é a probabilidade de você recomendar o PrintOS a um colega?",
      notLikely: "Nada provável",
      likely: "Muito provável",
      send: "Enviar feedback",
      response: {
        detractor: "{0}, o que podemos fazer para melhorar a sua experiência do PrintOS? Nós lemos todos os comentários.",
        detractorNameless: "O que podemos fazer para melhorar o PrintOS? Todos os comentários são relevantes.",
        passive: "{0}, diga-nos como melhorar a sua experiência no PrintOS. Nós lemos todos os comentários.",
        passiveNameless: "Diga-nos como melhorar a sua experiência no PrintOS. Nós lemos todos os comentários.",
        promoter: "{0}, adoramos saber que você está gostando de usar o PrintOS! Diga-nos por quê. Nós lemos todos os comentários.",
        promoterNameless: "Adoramos saber que você está gostando de usar o PrintOS! Diga-nos por quê. Nós lemos todos os comentários.",
      },
      introMorning: "Bom dia {0}, meu nome é Jon, Gerente de Sucesso do Cliente para PrintOS.",
      introMorningNameless: "Bom dia, meu nome é Jon, Gerente de Sucesso do Cliente para PrintOS.",
      introAfternoon: "Bom tarde {0}, meu nome é Jon, Gerente de Sucesso do Cliente para PrintOS.",
      introAfternoonNameless: "Bom tarde, meu nome é Jon, Gerente de Sucesso do Cliente para PrintOS.",
      introEvening: "Bom noite {0}, meu nome é Jon, Gerente de Sucesso do Cliente para PrintOS.",
      introEveningNameless: "Bom noite, meu nome é Jon, Gerente de Sucesso do Cliente para PrintOS.",
      intro2: "Ajude-me a entender a sua experiência com o PrintOS respondendo a esta pergunta:",
      intro3: "Qual é a probabilidade de você recomendar o PrintOS a um colega?",
      detractorResponse: "Agradecemos a resposta, {0}! Valorizamos comentários positivos e críticos.",
      detractorResponseNameless: "Agradecemos a resposta! Valorizamos comentários positivos e críticos.",
      promoterResponse: "Obrigado(a), {0}! É ótimo saber que você é fã do PrintOS. Seu comentário pode nos ajudar a oferecer uma experiência ainda melhor.",
      promoterResponseNameless: "Obrigado(a)! É ótimo saber que você é fã do PrintOS. Seu comentário pode nos ajudar a oferecer uma experiência ainda melhor.",
      response2: "Escolha um aplicativo e diga-nos como podemos melhorar o PrintOS para você.",
      response3: "Todos os comentários são analisados pela equipe de sucesso do cliente. Podemos entrar em contato com você para entender melhor seu feedback.",
      feedbackPlaceholder: "Você pode melhorar o PrintOS da seguinte maneira...",
      application: "Aplicativo",
      noApplication: "PrintOS - Comentários gerais"
    },
    subscription: {
      title: "Assinatura",
      subscribe: "Assine agora!",
      noticeSingular: "A assinatura de {0} expirará em {1} dia.",
      notice: "A assinatura de {0} expirará em {1} dias.",
    },
    promotion: {
      label: "Promoção",
      title: "Aviso do período promocional",
      notice: "Você está em um período promocional para este aplicativo.",
    },
    trial: {
      label: "O período de avaliação vencerá em breve",
      title: "Período de teste",
      noticeSingular: "{0} está em período de teste. A avaliação termina em {1} dia.",
      notice: "{0} está em período de teste. A avaliação termina em {1} dias.",
    },
    subscriptionExpired: {
      label: "Assinatura vencida",
      title: "Assinatura vencida",
      notice: "A assinatura de {0} venceu. Após um curto período gratuito, você não conseguirá mais acessar essa funcionalidade.",
    },
    trialExpired: {
      label: "Período de teste expirado",
      title: "Período de teste expirado",
      notice: "O período de avaliação de {0} venceu. Após um curto período gratuito, você não conseguirá mais acessar essa funcionalidade.",
    },
    hpWarning: "{0}\nVocê é um representante da HP Inc. na organização de um cliente. Tenha cuidado.",
    role: {
      HP_Operation: "Operação HP",
      HP_Sales_and_Marketing: "Interface com o cliente HP",
      SystemRoleGenesis_Admin: "Admin do serviço PrintOS",
      SystemRoleGenesis_Support: "Admin HP Inc.",
      SystemRoleGenesis_R_AND_D: "P&D Genesis",
      CE_Level_1: "CE Nível 1",
      CE_Level_2: "CE Nível 2",
      Application_Engineer: "Engenheiro de aplicativo",
      Ramp_Up_Engineer: "Engenheiro de instalação",
      Support_Engineer: "Engenheiro de suporte",
      Remote_Support_Engineer: "Engenheiro de assistência HP",
      Specialist: "Especialista",
      Certification_Centers: "Centros de certificação",
      Supplies_and_Media_Personnel: "Pessoal de suprimentos e mídia",
      Supplies_and_Media_Admin: "Administração de suprimentos e mídia",
      HP_Service: "HP Service ",
      HP_Training: "HP Training",
      Admin: "Administrador",
      Pre_Press_Operator: "Usuário",
      Press_Operator: "Operador",
      Dashboard: "Painel",
      Channel_Sales_and_Marketing: "Vendas e marketing de canal",
      Channel_Operation: "Operação de canal",
      Channel_CE_Level_1: "CE Canal Nível 1",
      Channel_CE_Level_2: "CE Canal Nível 2",
      HP_Read_Only: "Somente leitura HP",
      Reseller_Manager: "Gerente de revendedor",
      Business_Partner_Manager: "Gerente de parceiro comercial",
      Call_Center: "Central de atendimento",
      Field_Engineer: "Engenheiro de campo",
      ThreeD_Business_Manager: "3D Business Manager",
      HPInPsp: "HP no PSP",
      ChannelInPsp: "Canal no PSP",
      GenericAdmin: "Administrador",
      GenericUser1: "Nível de usuário 1",
      GenericUser2: "Nível do usuário 2",
      Generic_Read_Only: "Somente leitura",
      ThreeD_Care_Center: "3D Care Center",
      ThreeD_Cost_Calculator: "Orçamento 3D",
      Composer_External: "Acesso limitado - Composer",
      SIM_External: "Acesso limitado - Gerente de inventário de suprimentos",
      Multiple: "Várias funções"
    },
    inlineAlerts: {
      Http_429_Error: "Alto tráfego",
      Http_429_Description: "O serviço está enfrentando cargas anormais no momento. Algumas funcionalidades podem estar temporariamente indisponíveis. Atualize a página para tentar de novo",
      Http_429_Action: "Atualizar",
      NewSubscription: "Nova assinatura - {0}",
      NewSubscriptionDescription: "Sua organização tem uma nova assinatura",
      NewSubscriptionAction: "Saiba mais",
      SubscriptionExpired: "Assinatura vencida - {0}",
      SubscriptionExpiredDescription: "Sua assinatura venceu em {0}",
      SubscriptionExpiredAction: "Exibir assinatura",
      Subscription30DayWarning: "A assinatura vencerá - {0}",
      Subscription30DayWarningDescription: "Sua assinatura vencerá em {0} dias em {1}",
      Subscription30DayWarningAction: "Exibir assinatura",
      Subscription15DayWarning: "A assinatura vence em breve - {0}",
      Subscription15DayWarningDescription: "Sua assinatura vencerá em {0} dias em {1}",
      Subscription15DayWarningAction: "Exibir assinatura",
      JoinOrgRequestAccepted: "Solicitação de adesão à organização aceita",
      JoinOrgRequestAcceptedDescription: "Você recebeu acesso a <b>{0}</b>",
      JoinOrgRequestSwitch: "Organização aberta",
      JoinOrgRequestDenied: "Solicitação de adesão à organização negada",
      JoinOrgRequestDeniedDescription: "O administrador negou sua solicitação de participação em <b>{0}</b>",
      NonHPContext: "Abrir janela de contexto não HP",
      NonHPContextDescription: "Contexto: {0}",
      CloseContext: "Fechar contexto"
    },
    ui: {
      Confirm: "Confirmar",
      Notify: "Notificação",
      OpenImage: "Abrir arquivo de imagem",
      Dismiss: "Descartar",
      CheckingContext: "Verificando o contexto...",
      LoadingContext: "Restaurando {0}..."
    }
  }
};
